<template>
  <!-- El contenedor que envuelve el contenido sobre el que se hace hover -->
  <div
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <!-- slot donde va el contenido que quieres que tenga tooltip -->
    <slot></slot>

    <!-- El globo del tooltip -->
    <div
      v-if="visible"
      class="tooltip-bubble"
      :style="tooltipStyle"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MyTooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "top", // top, bottom, left, right
    },
  },
  data() {
    return {
      visible: false, // Para controlar si el tooltip se ve o no
    };
  },
  computed: {
    tooltipStyle() {
      // Estilos básicos del globo
      const style = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        padding: "6px 8px",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        zIndex: "9999",
      };

      // Posiciones según la prop "position"
      switch (this.position) {
        case "top":
          style.bottom = "100%";
          style.left = "50%";
          style.transform = "translateX(-50%)";
          style.marginBottom = "5px";
          break;
        case "bottom":
          style.top = "100%";
          style.left = "50%";
          style.transform = "translateX(-50%)";
          style.marginTop = "5px";
          break;
        case "left":
          style.right = "100%";
          style.top = "50%";
          style.transform = "translateY(-50%)";
          style.marginRight = "5px";
          break;
        case "right":
          style.left = "100%";
          style.top = "50%";
          style.transform = "translateY(-50%)";
          style.marginLeft = "5px";
          break;
      }
      return style;
  }
  },
  methods: {
  showTooltip() {
    this.visible = true;
  },
  hideTooltip() {
    this.visible = false;
  },
  },
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  transition: ease-in 0.2s;
  user-select: none;
}

.tooltip-bubble {
  /* Additional styles for the tooltip bubble can be added here */
  transition: ease-in 0.2s;
}
</style>